export interface OnboardingPalette {
  backgroundColor: string;
  titleColor: string;
  subtitleColor: string;
  bodyColor: string;
}

const lightPalettes: OnboardingPalette[] = [
  { backgroundColor: '#e9f5f3', titleColor: '#43a49e', subtitleColor: '#035164', bodyColor: '#000000' },
  { backgroundColor: '#eeeef0', titleColor: '#5e52a3', subtitleColor: '#33264d', bodyColor: '#000000' },
  { backgroundColor: '#fef1dd', titleColor: '#f5a523', subtitleColor: '#8e183d', bodyColor: '#000000' },
  { backgroundColor: '#eaf8ff', titleColor: '#1473be', subtitleColor: '#00324a', bodyColor: '#000000' },
];

const darkPalettes: OnboardingPalette[] = [
  { backgroundColor: '#334853', titleColor: '#74CCBE', subtitleColor: '#d7eef0', bodyColor: '#f4fbfb' },
  { backgroundColor: '#403f5d', titleColor: '#c6bcff', subtitleColor: '#ece8ff', bodyColor: '#f5f3ff' },
  { backgroundColor: '#5a473d', titleColor: '#ffd27a', subtitleColor: '#ffb5c9', bodyColor: '#fff3e2' },
  { backgroundColor: '#27485f', titleColor: '#89d2ff', subtitleColor: '#ddf2ff', bodyColor: '#f3fbff' },
];

export const getOnboardingPalette = (index: number, isDarkMode: boolean): OnboardingPalette => {
  const palettes = isDarkMode ? darkPalettes : lightPalettes;
  return palettes[index] ?? palettes[0];
};
